// Pinia 2 store for Vue 2
import { defineStore } from "pinia";

export const useDashboardStore = defineStore("dashboards", {
  state: () => ({
    routes: [], // [{ id, name }, ...]
    isOpen: false, // collapse state for the dashboards section
  }),

  getters: {
    hasDashboards: (state) => state.routes.length >= 1,
    // keep sorted, but don't mutate original
    sortedRoutes: (state) =>
      [...state.routes].sort((a, b) => a.name.localeCompare(b.name)),
  },

  actions: {
    // --- helpers ---
    _toRoute(payload) {
      const name = String(payload?.name ?? "").trim();
      const id = Number(payload?.id ?? 0);

      return {
        id,
        name,
        to: {
          name: "DashboardPanel",
          params: { id: String(id) },
        },
      };
    },

    _indexByName(name) {
      return this.routes.findIndex((r) => r?.name === name);
    },

    _indexById(id) {
      return this.routes.findIndex((r) => r?.id === id);
    },

    // --- existing ---
    setRoutes(list) {
      list.forEach(element => {
        this.addRouteFromDashboard(element);
      });
    },
    loadFromSession(session) {
      const user = session?.get?.("user");
      const list = user?.dashboards ?? [];
      // map dashboards -> routes
      this.routes = list.map((d) => this._toRoute(d)).filter((r) => r.name); // keep only valid names
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    open(val) {
      this.isOpen = typeof val === "boolean" ? val : !this.isOpen;
    },
    clear() {
      this.routes = [];
      this.isOpen = false;
    },

    // --- new: add a single route from a Dashboard ---
    addRouteFromDashboard(dashboard) {
      const route = this._toRoute(dashboard);
      if (!route.name) return false; // invalid
      if (this._indexByName(route.name) !== -1) return false; // already exists
      this.routes.push(route);
      return true;
    },

    // --- new: update a route from a Dashboard (match by unique name) ---
    updateRouteFromDashboard(dashboard) {
      const route = this._toRoute(dashboard);
      if (!route.name) return false; // invalid
      const idx = this._indexByName(route.name);
      if (idx === -1) return false; // nothing to update
      // Update id (and name if you ever allow renames)
      this.routes[idx] = { ...this.routes[idx], ...route };
      return true;
    },

    // --- optional convenience: upsert (update or add) ---
    upsertRouteFromDashboard(dashboard) {
      console.log("update dashboard store", dashboard);
      const route = this._toRoute(dashboard);
      if (!route.name) return false;

      // make sure this exists and compares the same type (number vs string)
      const idx = this._indexById(route.id);

      if (idx === -1) {
        this.routes.push(route); // add is fine
      } else {
        this.routes.splice(idx, 1, {
          // ✅ reactive replace in Vue 2
          ...this.routes[idx],
          ...route,
        });
      }

      console.log(this.routes);
      return true;
    },
  },
});
